import TournamentsListItem from './TournamentsListItem';

export default TournamentsListItem;
